export interface SearchMatch {
  index: number
  preview: string
}

export function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

export function findMatches(text: string, query: string, limit = 50): SearchMatch[] {
  const normalized = query.trim().toLowerCase()
  if (!normalized) {
    return []
  }

  const source = text.toLowerCase()
  const matches: SearchMatch[] = []
  let index = source.indexOf(normalized)

  while (index !== -1 && matches.length < limit) {
    const start = Math.max(0, index - 28)
    const end = Math.min(text.length, index + normalized.length + 28)
    matches.push({
      index,
      preview: text.slice(start, end).replace(/\s+/g, ' ').trim(),
    })
    index = source.indexOf(normalized, index + normalized.length)
  }

  return matches
}

export function highlightText(text: string, query: string): string {
  const escaped = escapeHtml(text)
  const normalized = query.trim()

  if (!normalized) {
    return escaped
  }

  const pattern = new RegExp(`(${escapeRegExp(normalized)})`, 'gi')
  return escaped.replace(pattern, '<mark>$1</mark>')
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
